import React from 'react'
import { Card, CardBody, CardFooter } from 'reactstrap'
import { Link } from 'react-router-dom'
import { getCountry } from '../../i18n'

// The credential is consumed by the coordinator, so failures deliberately offer
// a fresh ordinary login instead of replaying a bearer link.
class Redirect extends React.Component {
  state = { status: 'loading' }

  componentDidMount() {
    const { authRuntime, redirectEntry, history } = this.props
    if (!authRuntime || !redirectEntry) {
      this.setState({ status: 'error' })
      return
    }
    authRuntime.redirect(redirectEntry)
      .then(() => {
        getCountry({ session: authRuntime.session })
        history.replace('/')
      })
      .catch(() => this.setState({ status: 'error' }))
  }

  render() {
    const loading = this.state.status === 'loading'
    return (
      <div className="login-page">
        <Card className="card-login" aria-live="polite">
          <CardBody>
            <p className="text-center">
              {loading ? 'Ingresando a Promo...' : 'No se pudo completar el ingreso.'}
            </p>
            {!loading && <p className="text-center">Solicitá un nuevo enlace o iniciá sesión.</p>}
          </CardBody>
          {!loading && <CardFooter className="text-center">
            <Link to="/login">Ir al inicio de sesión</Link>
          </CardFooter>}
        </Card>
      </div>
    )
  }
}

export default Redirect
